import React, {useEffect} from 'react'
import NodeOnlineRate from './node-online-rate'
import WarningInfo from './warning-info'
import EnergyConsumption from './energy-consumption'
import DeviceOnlineRate from './device-online-rate'
import ProgramList from './program-list'
import RealtimeMonitor from './realtime-monitor'
import IndexChart from './index-chart'
import './index.less'

export default function CockpitIndex() {
  return (
    <React.Fragment>
      <IndexChart />
      <div className="ck-index-right">
        <div className="ck-index-item">
          <NodeOnlineRate />
          <ProgramList />
        </div>
        <div className="ck-index-item">
          <EnergyConsumption />
          <DeviceOnlineRate />
        </div>
        <div className="ck-index-item">
          <WarningInfo />
          <RealtimeMonitor />
        </div>
      </div>
    </React.Fragment>
  )
}
